export { SegmentedBar } from "./SegmentedBar";
export type { ISegment } from "./SegmentedBar.d";
